import axios, { AxiosResponse } from 'axios';
import { createImageUploadFormData } from '@/utils/imageUpload';
import { EditorFile } from './types.ts';

export const uploadImages = (files?: EditorFile[] | null): Promise<AxiosResponse[] | null> =>
    new Promise((resolve, reject) => {
        if (!files || !Array.isArray(files) || files.length === 0) {
            resolve(null);
            return;
        }

        const uploadPromises = files.map(async (file) => {
            if (file && file.file) {
                const data = await createImageUploadFormData(file.file);
                return axios.post('/upload/image/post', data, {
                    withCredentials: true,
                });
            }
            if (file && file.url) {
                return Promise.resolve({
                    data: {
                        url: file.url,
                    },
                } as AxiosResponse);
            }
            return Promise.resolve(null as unknown as AxiosResponse);
        });

        Promise.all(uploadPromises)
            .then((response) => resolve(response.filter(Boolean) as AxiosResponse[]))
            .catch((error) => reject(error));
    });

export const submitPostRequest = (isUpdate: boolean, payload: any) =>
    axios({
        method: isUpdate ? 'PUT' : 'POST',
        url: '/post',
        data: payload,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
        },
    });
